import React, { useEffect, useState, useRef } from "react";
import { useStore } from "@/context/StoreContext";

const load = (k, d) => { try { return JSON.parse(localStorage.getItem(k)) ?? d; } catch { return d; } };

let injected = false;
const injectAnalytics = (settings, consent) => {
  if (injected || !consent?.analytics) return;
  const a = settings?.analytics || {};
  if (a.ga_id) {
    const s = document.createElement("script"); s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${a.ga_id}`; document.head.appendChild(s);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () { window.dataLayer.push(arguments); };
    window.gtag("js", new Date()); window.gtag("config", a.ga_id);
  }
  if (consent?.marketing && a.meta_pixel_id) {
    /* eslint-disable */
    !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');
    window.fbq("init", a.meta_pixel_id); window.fbq("track", "PageView");
    /* eslint-enable */
  }
  injected = true;
};

export const trackEvent = (name, params = {}) => {
  try {
    if (window.gtag) window.gtag("event", name, params);
    if (window.fbq) window.fbq("track", name, params);
  } catch {}
};

const ConsentBanner = () => {
  const { settings } = useStore();
  const [consent, setConsent] = useState(() => load("nba_consent", null));
  const applied = useRef(false);

  useEffect(() => {
    if (consent && settings && !applied.current) { injectAnalytics(settings, consent); applied.current = true; }
  }, [consent, settings]);

  const choose = (c) => { localStorage.setItem("nba_consent", JSON.stringify(c)); setConsent(c); window.dispatchEvent(new Event("nba-consent")); };

  if (consent) return null;
  return (
    <div className="fixed bottom-0 inset-x-0 z-40 bg-cocoa text-cream px-4 py-3 md:px-8" data-testid="consent-banner">
      <div className="max-w-[1600px] mx-auto flex flex-col sm:flex-row sm:items-center gap-3 justify-between">
        <p className="text-[0.68rem] md:text-xs text-cream/80 leading-relaxed max-w-2xl">
          We use necessary cookies to run NoirbyAmara, plus optional analytics &amp; marketing cookies. You choose.
        </p>
        <div className="flex flex-wrap gap-2 shrink-0">
          <button data-testid="consent-necessary" onClick={() => choose({ necessary: true, analytics: false, marketing: false })}
            className="border border-cream/40 px-3 py-2 text-[0.62rem] tracking-[0.14em] uppercase hover:bg-cream/10">Necessary only</button>
          <button data-testid="consent-analytics" onClick={() => choose({ necessary: true, analytics: true, marketing: false })}
            className="border border-cream/40 px-3 py-2 text-[0.62rem] tracking-[0.14em] uppercase hover:bg-cream/10">Analytics</button>
          <button data-testid="consent-all" onClick={() => choose({ necessary: true, analytics: true, marketing: true })}
            className="bg-cream text-cocoa px-3 py-2 text-[0.62rem] tracking-[0.14em] uppercase hover:bg-gold hover:text-cream">Accept all</button>
        </div>
      </div>
    </div>
  );
};

export default ConsentBanner;
